module.exports = __webpack_public_path__ + "static/media/img5.00d40d9f.jpg";